export function translateAvancement(avancement, props, typePrestation?) {
  const TabPrestationStatus = {
    Draft:
      typePrestation === "PlanDecoration"
        ? props.t("project.prestations.avancements.draftDeco")
        : props.t("project.prestations.avancements.draft"),
    Modelisation: props.t("project.prestations.avancements.modelisation"),
    Graphics: props.t("project.prestations.avancements.graphics"),
    Changing: props.t("project.prestations.avancements.changing"),
    WaitPov: props.t("project.prestations.avancements.waitPov"),
    WaitValidClient: props.t("project.prestations.avancements.waitValidClient"),
    Valid: props.t("project.prestations.avancements.valid"),
    WaitValidInternal: props.t(
      "project.prestations.avancements.waitValidInternal"
    ),
    Delivery: props.t("project.prestations.avancements.delivery")
  };
  return TabPrestationStatus[avancement];
}



// WEBPACK FOOTER //
// ./src/helpers/translateAvancementPrestation.ts